
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "Changelog 2: Constants are Changing";
export const description = "It's about time I redecorated. Let's jump into 10.0.0.";
export const image = "/blog-images/site-1001.jpg";
export const tags = ["Meta", "Changelog", "Devlog", "Update"];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    img: "img",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/site-1001.jpg",
        alt: "A screenshot of this website"
      })
    }), "\n", _jsx(_components.p, {
      children: "This website's looked more-or-less the same since the start of 2026, but when a friend of mine offered to draw me a new profile picture, I knew I had to also give my site a facelift along with that."
    }), "\n", _jsx(_components.h2, {
      children: "What's stayed the same"
    }), "\n", _jsx(_components.p, {
      children: "I've kept the same interactive grid background, project card grid (which progressively enhances to a beautiful masonry layout on browsers with the correct feature flags enabled), and the same general content."
    }), "\n", _jsx(_components.h2, {
      children: "Reworked layout"
    }), "\n", _jsx(_components.p, {
      children: "While 9.x was pretty compact and space-efficient, the text-heavy nature of my site just didn't make sense for that kind of layout. That's why 10.0 takes more advantage of larger screen sizes, and places navigation in a more familiar area. The navigation bar floats over the content and is backed by a beautiful progressive blur effect for maximum legibility."
    }), "\n", _jsx(_components.h2, {
      children: "Live cards"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/site-livecards.jpg",
        alt: "The Mastodon and Last.fm widgets"
      })
    }), "\n", _jsx(_components.p, {
      children: "Quite a few other people's websites have widgets displaying live info. I put off adding this for a while since this site is on a static host, but I finally got around to spinning something up on a Cloudflare Worker. For now, there's only two: my latest post on the Fediverse, and my latest scrobble on Last.fm."
    }), "\n", _jsx(_components.h2, {
      children: "New typography"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/geist-pixel-demo.png",
        alt: "An example of the 5 main shape variants of Geist Pixel"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["I swapped out the main body and header text with Geist Pixel, a frankly incredible typeface created by the talented designers over at Vercel. The headlining feature is the ability to morph the font shape using the ELSH axis. I also replaced the ", _jsx(_components.code, {
        children: "monospaced"
      }), " font with Cascadia Code from Microsoft."]
    }), "\n", _jsx(_components.h2, {
      children: "Somewhere Right Now In The Future"
    }), "\n", _jsx(_components.p, {
      children: "Sometime soon, I'd like to add a couple more live cards, and maybe even join a webring or two. Otherwise, I'm pretty happy with the current state of things."
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	